import React from "react";
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="document-container">
        <header className="header-policy">
            <img src="https://customer-assets.emergentagent.com/job_57c7f0f2-1ce5-418b-8c85-4edaf17ae25c/artifacts/z4zwe4ra_FullLogo_NoBuffer.jpg" alt="Luxtansa Resorts Logo" className="logo" />
            <h1 className="document-title">Privacy Policy</h1>
            <p className="document-subtitle">Luxtansa Resorts</p>
        </header>

        <div className="info-box">
            <p><strong>Effective Date:</strong> January 7, 2026</p>
        </div>

        <div className="intro-text">
            <p>Luxtansa Resorts ("Luxtansa", "we", "our", "us") respects your privacy. This Privacy Policy explains how we collect, use, share, and protect your information when you visit our website <a href="https://www.luxtansaresorts.com" target="_blank">https://www.luxtansaresorts.com</a> ("Website"), contact us, or book/stay with us.</p>
        </div>

        <div className="section">
            <h2 className="section-title-policy"><span className="section-number">1</span>Information We Collect</h2>
            <div className="section-content">
                <p>We may collect the following types of information:</p>
                
                <div className="data-category">
                    <strong>Personal Information:</strong> name, phone number, email address, address (if provided), government ID details (only if required for check-in/compliance), and booking details.
                </div>
                
                <div className="data-category">
                    <strong>Booking & Stay Information:</strong> dates of stay, number of guests, preferences, special requests, feedback.
                </div>
                
                <div className="data-category">
                    <strong>Payment Information:</strong> payment status/transaction references (note: if payments are processed via a third-party payment gateway, we do not store full card details).
                </div>
                
                <div className="data-category">
                    <strong>Website/Device Information</strong> (automatically collected): IP address, browser type, device info, pages visited, and approximate location (based on IP).
                </div>
            </div>
        </div>

        <div className="section">
            <h2 className="section-title-policy"><span className="section-number">2</span>How We Use Your Information</h2>
            <div className="section-content">
                <p>We use your information to:</p>
                <ul className="use-list">
                    <li>Manage inquiries and process bookings</li>
                    <li>Confirm reservations, send updates, and provide customer support</li>
                    <li>Provide check-in/check-out and guest services</li>
                    <li>Improve our services, website, and guest experience</li>
                    <li>Maintain security and prevent fraud or misuse</li>
                    <li>Comply with legal obligations (as applicable)</li>
                </ul>
            </div>
        </div>

        <div className="section">
            <h2 className="section-title-policy"><span className="section-number">3</span>Cookies and Tracking</h2>
            <div className="section-content">
                <p>Our Website <a href="https://www.luxtansaresorts.com" target="_blank">https://www.luxtansaresorts.com</a> may use cookies and similar technologies to improve functionality and understand usage.</p>
                <div className="highlight-box">
                    <p>You can control cookies through your browser settings. Disabling cookies may affect some Website features.</p>
                </div>
            </div>
        </div>

        <div className="section">
            <h2 className="section-title-policy"><span className="section-number">4</span>Sharing of Information</h2>
            <div className="section-content">
                <p><strong>We do not sell your personal information.</strong> We may share information only when necessary, such as:</p>
                <ul>
                    <li><strong>Service providers</strong> (e.g., booking/CRM tools, payment gateways, SMS/email providers) to operate our services</li>
                    <li><strong>Legal authorities</strong> if required by law, regulation, or valid legal process</li>
                    <li><strong>Business protection</strong> to enforce our terms, prevent fraud, or protect rights and safety</li>
                </ul>
            </div>
        </div>

        <div className="section">
            <h2 className="section-title-policy"><span className="section-number">5</span>Data Security</h2>
            <div className="section-content">
                <p>We take reasonable security measures to protect information from unauthorized access, alteration, disclosure, or destruction.</p>
                <div className="highlight-box">
                    <p><strong>Note:</strong> No online transmission is 100% secure.</p>
                </div>
            </div>
        </div>

        <div className="section">
            <h2 className="section-title-policy"><span className="section-number">6</span>Data Retention</h2>
            <div className="section-content">
                <p>We retain personal information only as long as needed for:</p>
                <ul>
                    <li>Bookings and guest services</li>
                    <li>Business records</li>
                    <li>Legal/compliance requirements (as applicable)</li>
                </ul>
            </div>
        </div>

        <div className="section">
            <h2 className="section-title-policy"><span className="section-number">7</span>Your Choices and Rights</h2>
            <div className="section-content">
                <p>Depending on applicable laws, you may request to:</p>
                <ul>
                    <li>Access or correct your personal information</li>
                    <li>Withdraw consent for certain communications</li>
                    <li>Request deletion (where legally permitted)</li>
                </ul>
                <div className="highlight-box">
                    <p>To make a request, contact us using the details below.</p>
                </div>
            </div>
        </div>

        <div className="section">
            <h2 className="section-title-policy"><span className="section-number">8</span>Children's Privacy</h2>
            <div className="section-content">
                <p>Our Website and services are not intended for children. We do not knowingly collect personal information from minors.</p>
            </div>
        </div>

        <div className="section">
            <h2 className="section-title-policy"><span className="section-number">9</span>Third-Party Links</h2>
            <div className="section-content">
                <p>Our Website <a href="https://www.luxtansaresorts.com" target="_blank">https://www.luxtansaresorts.com</a> may contain links to third-party sites (e.g., maps, social media, payment gateways).</p>
                <div className="highlight-box">
                    <p><strong>Note:</strong> We are not responsible for their privacy practices.</p>
                </div>
            </div>
        </div>

        <div className="section">
            <h2 className="section-title-policy"><span className="section-number">10</span>Changes to This Privacy Policy</h2>
            <div className="section-content">
                <p>We may update this policy from time to time. Updates will be posted on <a href="https://www.luxtansaresorts.com" target="_blank">https://www.luxtansaresorts.com</a> with a revised effective date.</p>
            </div>
        </div>

        <div className="contact-section-policy">
            <h3>Contact Us</h3>
            <p style={{ marginBottom: "5px" }}>If you have questions or requests about this Privacy Policy, contact:</p>
            <p style={{ marginBottom: "20px", fontSize: "18px", fontWeight: "600" }}>Luxtansa Resorts</p>
            <div className="contact-info">
                <div className="contact-item">
                    <div className="contact-label">Website</div>
                    <div className="contact-value"><a href="https://www.luxtansaresorts.com" target="_blank">www.luxtansaresorts.com</a></div>
                </div>
                <div className="contact-item">
                    <div className="contact-label">Contact Person</div>
                    <div className="contact-value">Elango Kanakaraji</div>
                </div>
                <div className="contact-item">
                    <div className="contact-label">Email</div>
                    <div className="contact-value"><a href="mailto:luxtansaresorts@gmail.com">luxtansaresorts@gmail.com</a></div>
                </div>
                <div className="contact-item">
                    <div className="contact-label">Phone</div>
                    <div className="contact-value"><a href="tel:7358481281">7358481281</a></div>
                </div>
            </div>
        </div>

        <div className="footer-policy">
            <p>RELAX, REFRESH, RECHARGE</p>
        </div>
    </div>
  );
};

export default PrivacyPolicy;